<template>
  <div class="index-page">
    <div class="index-swiper-box swiper-no-swiping">
      <div class="swiper-text-con">
        <div class="text-content" v-for="(text, i) in swiperText" :key="i" :class="{'active': i === activeIndex}">
          <p class="title"> {{text.title}}</p>
          <p class="desc"> {{text.desc}} </p>
          <a class="register-btn" v-if="text.type === 'button'" href="https://account.xiaomi.com/pass/register"> 立即注册</a>
          <img class="register-img" v-if="text.type === 'qrcode'" src="http://cnbj1.fds.api.xiaomi.com/assets/emi/index/qrcode.png"/>
        </div>
      </div>
      <swiper class="swiper-con" ref="mySwiper" :options="swiperOpts" @slideChangeTransitionStart="slideStart">
        <swiper-slide>
          <img class="swiper-img banner1" src="http://cnbj1.fds.api.xiaomi.com/assets/emi/index/banner1.png"/>
          </swiper-slide>
        <swiper-slide class="mgt-40">
          <img class="swiper-img banner3" src="http://cnbj1.fds.api.xiaomi.com/assets/emi/index/banner3.png"/>
          </swiper-slide>
      </swiper>
      <div class="swiper-pagination">
        <span class="swiper-pagination-bullet" v-for="i in 3" :key="i" :class="{'swiper-pagination-bullet-active': activeIndex === i}"></span>
      </div>
    </div>
    <div class="index-section resource-section">
      <h1 class="section-title"> 资源介绍</h1>
      <div class="section-content">
        <div class="section-item" v-for="resource in resourceList" :key="resource.icon">
          <div class="section-info">
            <img class="resource-logo" :src="resource.icon" />
            <div class="section-text">
              <p class="section-name"> {{resource.name}}</p>
              <p class="section-desc"> {{resource.desc}}</p>
            </div>
          </div>
          <p class="section-link">
            <a class="section-link-btn" :href="resource.path"> 了解详情</a>
          </p>
        </div>
      </div>
    </div>
    <!-- <div class="index-section tool-section">
      <h1 class="section-title"> 必备工具满足所有需求</h1>
      <div class="section-content">
        <div class="section-item" v-for="item in toolList" :key="item.icon">
          <img class="tool-logo" :src="item.icon" />
          <div class="section-info">
            <p class="section-name"> {{item.name}}</p>
            <p class="section-desc"> {{item.desc}}</p>
            <p class="section-action">
              <a class="link-btn" :href="item.path"> 了解详情</a>
            </p>
          </div>
        </div>
        <div class="empty-item"></div>
      </div>
    </div> -->
    <div class="index-section help-section">
      <h1 class="section-title"> 帮助中心</h1>
      <div class="section-content">
        <div class="section-item" v-for="item in helpList" :key="item.path">
          <a class="hepl-link" :href="item.path" target="_blank" v-if="item.name">
            <span class="help-item-icon" :style="{'background': item.back}">
              <i :class="'iconfont ' + item.icon"></i>
            </span>
            <span class="help-item-name"> {{item.name}}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import 'swiper/dist/css/swiper.css';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  export default {
    name: 'index',
    components: {
      swiper,
      swiperSlide
    },
    data() {
      return {
        resourceList: [
          {name: '应用商店', icon: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/shop.png', desc: '应用下载中心，千亿级分发平台，多广告形式触达用户，助力应用快速增长', path: '#/resource/shop'},
          {name: '信息流媒体', icon: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/browser.png', desc: '高覆盖高活跃第一综合入口，原生信息流广告多角度触达用户', path: '#/resource/browser'},
          {name: '小米视频', icon: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/video.png', desc: '大流量 高粘性用户群，助力提升转化效果', path: '#/resource/video'},
          {name: '手机管家', icon: 'http://cnbj1.fds.api.xiaomi.com/assets/emi/index/manager.png', desc: 'MIUI系统人手必备，每日必用的软件', path: '#/resource/safe'}
        ],
        helpList: [
          {name: '平台资源', icon: 'iconEMI-42', path: 'http://e.mi.com/v2/dist/help.html#16', back: '#03a9f4'},
          {name: '常见问题', icon: 'iconEMI-25', path: 'http://e.mi.com/v2/dist/help.html#9', back: '#ffc107'},
          {name: '合作流程', icon: 'iconEMI-34', path: 'http://e.mi.com/v2/dist/help.html#15', back: '#00bcd4'},
          {name: '辅助工具', icon: 'iconEMI-33', path: 'http://e.mi.com/v2/dist/help.html#32', back: '#4caf50'},
          {name: '联系我们', icon: 'iconEMI-36', path: 'http://e.mi.com/v2/dist/help.html#48', back: '#ff5722'},
          {name: '投放指导', icon: 'iconEMI-24', path: 'http://e.mi.com/v2/dist/help.html#8', back: '#ff4081'},
          {name: '定向优化', icon: 'iconEMI-49', path: 'http://e.mi.com/v2/dist/help.html#31', back: '#ab47bc'},
          {}
        ],
        swiperOpts: {
          pagination: {
            el: '.swiper-pagination',
            clickable: false
          },
          effect: 'fade',
          autoplay: {
            autoplay: true,
            delay: 3000
          },
          loop: true,
          loopAdditionalSlides: 0
        },
        swiperText: [
          {title: '综合性一站式广告平台', desc: '聚合小米公司全量应用场景，具备更精准的人群匹配度，领跑厂商营销服务，助力最大化广告效果', type: 'button'},
          {title: '重大升级', desc: '全新广告投放平台，效率升级，聚焦体验', type: 'button'},
        ],
        activeIndex: 0,
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    created() {
      console.log('create')
    },
    methods: {
      slideStart() {
        let swiperLen = this.swiperText.length;
        this.activeIndex = this.swiper.activeIndex > swiperLen ? this.swiper.activeIndex - swiperLen - 1 : this.swiper.activeIndex - 1;
      }
    }
  }
</script>
<style lang="scss">
@use '../assets/scss/index.scss';
</style>